import { inject,Injectable } from '@angular/core';

import {
  MethodContextEnum,
  SOCIAL_AUTH_CONFIG,
  SocialNetworksEnum,
} from '@personal-area/global/social-authorization/models';

const SOCIAL_METHOD_MAPPING: Record<string, SocialNetworksEnum> = {
  facebook: SocialNetworksEnum.Facebook,
  google: SocialNetworksEnum.Google,
  apple: SocialNetworksEnum.Apple,
} as const;

@Injectable({ providedIn: 'root' })
export class SocialAuthConfigService {
  private readonly _config = inject(SOCIAL_AUTH_CONFIG);

  public isCompletelyDisabled(context: MethodContextEnum): boolean {
    return this._config.completelyDisabled[context] || false;
  }

  public getDisabledMethods(context: MethodContextEnum): SocialNetworksEnum[] {
    const disabledIds = this._config.disabled[context] || [];

    return disabledIds
      .map((id) => SOCIAL_METHOD_MAPPING[id.toLowerCase()])
      .filter(Boolean) as SocialNetworksEnum[];
  }

  public isMethodDisabled(
    method: SocialNetworksEnum,
    context: MethodContextEnum,
  ): boolean {
    return this.getDisabledMethods(context).includes(method);
  }
}
